import { api } from "../../../configs/api";
import { defaultHeaders } from "../../../configs/config";
import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
export const goToEmail = async (action, _datastore, { showPopup, setDatastore }) => {
    console.warn("**** goToEmail action ****", action);
    await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
        emailLoading: true
    });
    const requestOptions = {
        method: "GET",
        headers: await defaultHeaders(),
    };
    const accountId = (await SharedPropsService.getUser())
        .linkedBorrowerAccounts[0].accountId;
    await fetch(`${api.pdfEmail}${accountId}`, requestOptions)
        .then((response) => {
        response.json();
        if (response?.status === 200) {
            setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
                emailLoading: false,
                type: "SUCCESS",
                title: "Email sent successfully",
                subTitle: "Transaction details have been sent to your email address.",
                ctaLabel: "Continue",
            });
        }
        else {
            setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
                emailLoading: false,
                type: "FAILED",
                title: "Email sent unsuccessfully",
                subTitle: "Transaction details were not sent to your email address.",
                ctaLabel: "Try again later",
            });
        }
    })
        .catch((error) => async () => {
        await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
            emailLoading: false,
            type: "FAILED",
            title: "Email sent unsuccessfully",
            subTitle: "Transaction details were not sent to your email address.",
            ctaLabel: "Try again later",
        });
    });
};
export const closeLoader = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
        emailLoading: false
    });
};
export const navigation = async (action, _datastore, { navigate, setDatastore }) => {
    console.warn("*** navigationAction props ***", action);
    const routeId = action.payload.routeId;
    if (routeId === 'DASHBOARD') {
        await navigate(ROUTE.DASHBOARD, {
            cacheManageLimitConfig: true,
            cacheCreditData: true,
            cachePendingCreditRequestByCreditId: true,
            // cacheUserContext: true
        });
        await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
            isFromRejectedWithdrawa: false
        });
    }
    else if (routeId === 'MANAGE_LIMIT') {
        await navigate(ROUTE.MANAGE_LIMIT, {
            cacheManageLimitConfig: false,
            cacheCreditData: true,
            cachePendingCreditRequestByCreditId: true
        });
        await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
            isFromRejectedWithdrawa: false
        });
    }
    else {
        await navigate(routeId);
    }
};
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const hidePopup = async (action, _datastore, { hidePopup }) => {
    await hidePopup();
};
export const goBackAction = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const goToRepaymentAction = async (action, _datastore, { navigateWithClear }) => {
    const amount = action?.payload?.amount;
    await navigateWithClear(ROUTE.PAYMENT_START, {
        isFromTransactions: true,
        amount: amount
    });
};
